import { HelpfulTopicsContainer } from 'containers'
import { Row, Col, Alert } from 'react-bootstrap'
import styled from 'styled-components'
import List from 'components/List'
import Panel from 'components/Panel'
import InlineLoader from 'components/InlineLoader'
import InternalLink from 'components/InternalLink'
import CategoryToggle from 'components/CategoryToggle'

const StyledList = styled(List)`
  padding: 10px 10px 10px 25px;
`

const TutorialList = ({
  tutorials,
  isFetching,
  deviceId,
  currentCategory,
  handleClick,
  icon,
  productNameSingular = ''
}) => {
  const productName = productNameSingular.toLowerCase() || 'device'

  const tutorialList = (tutorials) =>
    tutorials.map((tutorial) => (
      <li key={tutorial.pk}>
        <InternalLink to={`/tutorial/${tutorial.pk}?device=${deviceId}`}>
          {tutorial.name}
        </InternalLink>
      </li>
    ))

  const categories = () =>
    tutorials.map((cat) => {
      const active = cat.name === currentCategory
      return (
        <div key={cat.name}>
          <CategoryToggle
            title={cat.name}
            active={active}
            icon={icon(cat.name)}
            handleClick={handleClick.bind(this, cat.name)}
          >
            <StyledList>{tutorialList(cat.children)}</StyledList>
          </CategoryToggle>
        </div>
      )
    })

  const content = () => {
    if (isFetching) {
      return <InlineLoader />
    }

    if (!deviceId) {
      return (
        <Alert bsStyle="info">
          Please select a {productName} from {productName} search to view
          tutorials.
        </Alert>
      )
    }

    if (!tutorials.length) {
      return (
        <Alert bsStyle="warning">
          No tutorials found for current {productName}.
        </Alert>
      )
    }

    return categories()
  }

  return (
    <Row>
      <Col xs={12} md={9}>
        <Panel title="Tutorials">{content()}</Panel>
      </Col>
      <Col xs={12} md={3}>
        <HelpfulTopicsContainer />
      </Col>
    </Row>
  )
}

export default TutorialList
